module.exports = __webpack_public_path__ + "img/shortcodes-sprite.754af70b.png";